// English source strings of the Agents & Models page (decision D20, slice L1b-ii): registry, learnings, scores
// and recommendations. Merged into `en`; pt-BR lives in pt-BR-agents.ts (complete, checked by the type).
export const enAgents = {
  "agents.learnings.independent.latest": "Latest independent review: {decision}",
  "agents.learnings.independent.decision.approve": "Approved",
  "agents.learnings.independent.decision.reject": "Rejected",
  "agents.learnings.independent.decision.defer": "Deferred",
  "agents.learnings.independent.reviewer": "Reviewer: {reviewer}",
  "agents.learnings.independent.model": "Model target: {model}",
  "agents.learnings.independent.provenance": "Review provenance",
  "agents.learnings.independent.notRecorded": "Not recorded",
  "agents.learnings.independent.reviewId": "Review ID",
  "agents.learnings.independent.learningVersion": "Reviewed learning version",
  "agents.learnings.independent.reviewedAt": "Reviewed at",
  "agents.learnings.independent.reviewerId": "Reviewer profile ID",
  "agents.learnings.independent.reviewerVersion": "Reviewer version ID",
  "agents.learnings.independent.modelCall": "Recorded model call ID",
  "agents.learnings.independent.evidenceFingerprint": "Evidence fingerprint",
  "agents.learnings.independent.evidence": "Evidence references",
  "agents.learnings.independent.sourceRun": "Source run ID",
  "agents.learnings.independent.sourceAttempt": "Source attempt ID",
  "agents.learnings.independent.candidate": "Reviewed candidate hash",
  "agents.learnings.independent.unavailable": "Independent review history is unavailable.",
  "agents.learnings.independent.window": "Review details show the latest independent review for each visible learning.",
  "agents.detail.actor.user": "Human",
  "agents.detail.actor.agent": "AI agent",
  "agents.detail.actor.service": "AI / service",
  "agents.detail.actor.system": "System",
  "agents.detail.actor.integration": "Integration",
  "agents.detail.actor.unknown": "Unknown author",
  "agents.sections": "Agents sections",
  "agents.tab.registry": "Agents",
  "agents.tab.learnings": "Learnings",
  "agents.tab.scores": "Scores & recommendations",
  "agents.tab.config": "Models & quotas",
  "agents.subtitle.registry": "The agents that work on your tasks: what each one does, its version and its measured results.",
  "agents.subtitle.learnings": "What the agents learned, per project and per agent. Nothing reaches a prompt without review.",
  "agents.subtitle.scores": "Measured results per agent version and what to improve next. People decide; nothing changes on its own.",

  "agents.origin.all": "All",
  "agents.origin.platform": "Platform template",
  "agents.origin.organization": "Organization",

  "agents.registry.search": "Search agents",
  "agents.registry.searchPlaceholder": "Name, key or specialty…",
  "agents.registry.role": "Role",
  "agents.registry.allRoles": "All roles",
  "agents.registry.originFilter": "Filter by origin",
  "agents.registry.sync": "Sync catalog",
  "agents.registry.syncHint": "Brings the platform agents and knowledge packs of this release. Agents edited in your organization are never overwritten.",
  "agents.registry.synced": "Catalog {version} synced: {created} created, {updated} updated, {unchanged} unchanged, {available} with an update to review, {conflicts} key conflicts. Learnings imported: {learnings}.",
  "agents.registry.syncFailed": "Could not sync the catalog",
  "agents.registry.loading": "Loading agents",
  "agents.registry.loadFailed": "Could not load the agents",
  "agents.registry.emptyTitle": "No agents yet",
  "agents.registry.emptyBody": "Sync the platform catalog to add the pre-configured agents: orchestrator, planner, developers, QA and reviewers.",
  "agents.registry.emptyBodyMember": "An organization admin can sync the platform catalog to add the pre-configured agents.",
  "agents.registry.noMatchTitle": "No agent matches the filters",
  "agents.registry.clearFilters": "Clear filters",
  "agents.registry.count": "{n} agents shown",

  "agents.card.open": "Open {name}",
  "agents.card.version": "v{n}",
  "agents.card.noVersion": "no version",
  "agents.card.project": "Project agent",
  "agents.card.updateAvailable": "Catalog update {version} available",
  "agents.card.updateAvailableHint": "This agent was edited in your organization, so the new catalog version was not applied. Review it before updating.",

  "agents.score.value": "{score}/100",
  "agents.score.detail": "lower bound {bound} · {runs} runs",
  "agents.score.insufficient": "Insufficient sample ({runs}/{min} runs)",
  "agents.score.none": "No runs in {days} days",
  "agents.score.unavailable": "Scores unavailable",

  "agents.detail.loading": "Loading the agent",
  "agents.detail.loadFailed": "Could not load the agent",
  "agents.detail.facts": "Agent facts",
  "agents.detail.key": "Key",
  "agents.detail.role": "Role",
  "agents.detail.origin": "Origin",
  "agents.detail.state": "State",
  "agents.detail.version": "Current version",
  "agents.detail.scope": "Available to",
  "agents.detail.orgWide": "Whole organization",
  "agents.detail.catalog": "Catalog",
  "agents.detail.update": "Catalog update",
  "agents.detail.score": "Measured results ({days} days)",
  "agents.detail.description": "When to use",
  "agents.detail.instructions": "Instructions",
  "agents.detail.instructionsHint": "The platform's common rules are added before these instructions when the agent runs.",
  "agents.detail.specialties": "Specialties",
  "agents.detail.delegatesTo": "Delegates to",
  "agents.detail.consultsTo": "Consults",
  "agents.detail.memoryScopes": "Learnings it reads",
  "agents.detail.tools": "Tools",
  "agents.detail.grants": "Integration operations",
  "agents.detail.grant": "card {card}, permission: {permission}",
  "agents.detail.none": "None",
  "agents.detail.versions": "Versions",
  "agents.detail.versionItem": "Version {n}",
  "agents.detail.versionCurrent": "current",
  "agents.detail.noteEmpty": "No change note",
  "agents.detail.versionTools": "{tools} tools · {grants} integration operations",
  "agents.permission.ler": "read",
  "agents.permission.enviar": "send",

  "agents.scope.agent_project": "Agent in a project",
  "agents.scope.project": "Project",
  "agents.scope.agent": "Agent",
  "agents.scope.organization": "Organization",
  "agents.scope.platform": "Platform",

  "agents.kind.structure_issue": "Structure issue",
  "agents.kind.practice": "Practice",
  "agents.kind.pitfall": "Pitfall",
  "agents.kind.procedure": "Procedure",
  "agents.kind.preference": "Preference",
  "agents.kind.fact": "Fact",

  "agents.status.proposed": "To review",
  "agents.status.approved": "Approved",
  "agents.status.rejected": "Rejected",
  "agents.status.deprecated": "Deprecated",
  "agents.status.superseded": "Superseded",

  "agents.learnings.filters": "Filter learnings",
  "agents.learnings.status": "Status",
  "agents.learnings.allStatuses": "All statuses",
  "agents.learnings.scope": "Scope",
  "agents.learnings.allScopes": "All scopes",
  "agents.learnings.kind": "Kind",
  "agents.learnings.allKinds": "All kinds",
  "agents.learnings.search": "Search learnings",
  "agents.learnings.searchPlaceholder": "Words in the title or text…",
  "agents.learnings.new": "New learning",
  "agents.learnings.readOnly": "Only organization admins and maintainers review learnings.",
  "agents.learnings.loading": "Loading learnings",
  "agents.learnings.loadFailed": "Could not load the learnings",
  "agents.learnings.emptyTitle": "No learnings here",
  "agents.learnings.emptyBody": "Agents propose learnings at the end of their work; reviewed knowledge packs arrive with the catalog sync.",
  "agents.learnings.queueEmptyTitle": "Nothing to review",
  "agents.learnings.queueEmptyBody": "New proposals from agents appear here before they reach any prompt.",
  "agents.learnings.count": "{n} learnings shown",
  "agents.learnings.tainted": "Came from external content — review carefully",
  "agents.learnings.taintedHint": "The agent read a web page, e-mail or message while producing this learning: it may carry instructions planted by third parties.",
  "agents.learnings.confidence": "Confidence {value}",
  "agents.learnings.uses": "Used {retrieved}× · helped {helpful} · hurt {harmful}",
  "agents.learnings.source.agent_run": "Proposed by an agent",
  "agents.learnings.source.human": "Written by a person",
  "agents.learnings.source.knowledge_pack": "Knowledge pack {pack}",
  "agents.learnings.createdAt": "Created {when}",
  "agents.learnings.expires": "Expires {when}",
  "agents.learnings.approve": "Approve",
  "agents.learnings.reapprove": "Approve again",
  "agents.learnings.reject": "Reject",
  "agents.learnings.deprecate": "Deprecate",
  "agents.learnings.actionLabel": "{action}: {title}",

  "agents.review.title.approve": "Approve learning",
  "agents.review.title.reject": "Reject learning",
  "agents.review.title.deprecate": "Deprecate learning",
  "agents.review.body.approve": "Approved learnings are retrieved into the prompts of the agents in their scope, marked with their origin.",
  "agents.review.body.reject": "Rejected learnings are never retrieved. The record stays for audit.",
  "agents.review.body.deprecate": "Deprecated learnings stop being retrieved. You can approve them again later.",
  "agents.review.note": "Note for the audit log",
  "agents.review.noteHint": "Never include personal data or credentials.",
  "agents.review.confirm.approve": "Approve",
  "agents.review.confirm.reject": "Reject",
  "agents.review.confirm.deprecate": "Deprecate",
  "agents.review.done.approve": "Learning approved.",
  "agents.review.done.reject": "Learning rejected.",
  "agents.review.done.deprecate": "Learning deprecated.",

  "agents.newLearning.title": "New learning",
  "agents.newLearning.description": "One lesson that helps agents in future tasks. Shared with every member and agent in its scope: no personal data, no credentials.",
  "agents.newLearning.scope": "Applies to",
  "agents.newLearning.scope.project": "One project (every agent)",
  "agents.newLearning.scope.agent_project": "One agent in one project",
  "agents.newLearning.scope.agent": "One agent (every project)",
  "agents.newLearning.scope.organization": "The whole organization",
  "agents.newLearning.kind": "Kind",
  "agents.newLearning.project": "Project",
  "agents.newLearning.agent": "Agent",
  "agents.newLearning.choose": "Choose…",
  "agents.newLearning.titleField": "Title",
  "agents.newLearning.titleHint": "Short and specific (3–160 characters).",
  "agents.newLearning.body": "Lesson",
  "agents.newLearning.bodyHint": "What to do or avoid, and why (3–4000 characters).",
  "agents.newLearning.expires": "Expires on",
  "agents.newLearning.expiresHint": "After this date the learning stops being retrieved unless it is confirmed again.",
  "agents.newLearning.submit": "Save learning",
  "agents.newLearning.required": "Choose one",
  "agents.newLearning.tooShort": "Write at least 3 characters",
  "agents.newLearning.doneApproved": "Learning saved and approved.",
  "agents.newLearning.doneProposed": "Learning saved; it waits for review.",
  "agents.newLearning.duplicate": "This learning already exists in this scope; nothing was added.",

  "agents.scores.window": "Period",
  "agents.scores.days": "{n} days",
  "agents.scores.title": "Scores per version",
  "agents.scores.hint": "From attempts that ended in the period. A score appears once a version has enough runs; the lower bound keeps small samples from looking better than they are.",
  "agents.scores.loading": "Loading scores",
  "agents.scores.loadFailed": "Could not load the scores",
  "agents.scores.emptyTitle": "No results in this period",
  "agents.scores.emptyBody": "Scores appear after agents finish attempts on tasks.",
  "agents.scores.tableLabel": "Scores per agent version",
  "agents.scores.col.agent": "Agent",
  "agents.scores.col.version": "Version",
  "agents.scores.col.runs": "Runs",
  "agents.scores.col.success": "Success",
  "agents.scores.col.bound": "Lower bound",
  "agents.scores.col.firstPass": "First pass",
  "agents.scores.col.interventions": "Human help",
  "agents.scores.col.rework": "Rework",
  "agents.scores.col.cost": "Avg cost",
  "agents.scores.col.duration": "Avg time",
  "agents.scores.col.score": "Score",
  "agents.scores.unversioned": "before versions",
  "agents.scores.unknown": "unknown",
  "agents.scores.unknownAgent": "Agent not visible",

  "agents.recs.title": "Recommendations",
  "agents.recs.hint": "Computed from the scores and from the learnings waiting for review. Accepting records your decision; agents are still changed by people.",
  "agents.recs.readOnly": "Only organization admins and maintainers decide recommendations.",
  "agents.recs.loading": "Loading recommendations",
  "agents.recs.loadFailed": "Could not load the recommendations",
  "agents.recs.emptyTitle": "No recommendations",
  "agents.recs.emptyBody": "Nothing needs attention in this period.",
  "agents.recs.kind.update_agent": "Update agent",
  "agents.recs.kind.create_agent": "Create agent",
  "agents.recs.kind.promote_version": "Promote version",
  "agents.recs.kind.retire_agent": "Retire agent",
  "agents.recs.kind.review_learning": "Review learning",
  "agents.recs.status.open": "Open",
  "agents.recs.status.accepted": "Accepted",
  "agents.recs.status.dismissed": "Dismissed",
  "agents.recs.subject.area": "Task type: {area}",
  "agents.recs.evidence": "Evidence",
  "agents.recs.decidedAt": "Decided {when}",
  "agents.recs.accept": "Accept",
  "agents.recs.dismiss": "Dismiss",
  "agents.recs.actionLabel": "{action}: {kind}",
  "agents.recs.done.accept": "Recommendation accepted.",
  "agents.recs.done.dismiss": "Recommendation dismissed.",
} as const;
